
import { Navigate } from "react-router";
import { PlatformProvidersIcon } from "../../../../shared/components/svgIcons";
import FeeList from "../components/feeList";
import FeeView from "../components/feeView";

const FeeListRoute = {
  link: "/fees",
  path: "/fees",
  name: "Fees ",
  element: "",
  icon: PlatformProvidersIcon,
  index: 4,
  children: [
    {
      path: "fee-structure",
      permission: "Fees",
      element: <FeeList />,
      link: "fees/fee-structure",
      name: "Fee Structure",
      icon: PlatformProvidersIcon,
    },
    {
      path: "fee-structure/:id",
      element: <FeeView />,
    },
    {
      path: "",
      element: <Navigate to="/fees/fee-structure" replace />,
    }
  ]
}
export default FeeListRoute;